export const SKILLS = {
  grammar: { label: "Grammaire", color: "#2563EB" },
  vocabulary: { label: "Vocabulaire", color: "#16A34A" },
  reading: { label: "Lecture", color: "#EA580C" },
  writing: { label: "Écriture", color: "#DB2777" },
  alphabet: { label: "Alphabet", color: "#CA8A04" },
  exam: { label: "Examen", color: "#4F46E5" },
};
export const skillColor = (s) => (SKILLS[s] || SKILLS.exam).color;
export const skillLabel = (s) => (SKILLS[s] || {}).label || s;
